import React from 'react';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import Cookies from 'js-cookie';
import { GoogleLogin } from 'react-google-login';
import api from '../../api';
import './index.css';

export default class Segmentation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        email: '',
        password: '',
      },
    }
  }
  componentDidMount = () => {
    document.title = "Login";
  }
  login() {
    const { user } = this.state;
    api.fetchAPI({
      method: 'post',
      uri: 'login',
      body: user,
      success: async (response) => {
        if (response.status === 'ok') {
          // Login success
          const token = response.access_token;
          await Cookies.set('access_token', token, { expires: 7 });
          await Cookies.set('email', user.email, { expires: 7 });
          await Cookies.set('user_id', response.id, { expires: 7 });

          // // Move to home
          window.location = '/';
        }
        else {
          alert(`Login failure: ${response.message}`);
        }
      },
      error: (error) => {
        console.error(error);
        alert('Login failure. Cannot call to server!')
      }
    });
  }
  editUserValue = ({ property, value }) => {
    const user = this.state.user;
    user[property] = value ? value : '';
    this.setState({ user });
  }
  responseGoogle(response) {
    const { accessToken, profileObj } = response;
    const { email, name } = profileObj;
    const user = {
      email,
      name,
      google_access_token: accessToken,
      login_method: 'google'
    }
    this.setState({ user }, this.login);
  }
  render() {
    return (
      <div className="main-login-form">
         <FormGroup>
          <Label>Email</Label>
          <Input value={this.state.user.email} type="email" placeholder="hello@datadex.vn" onChange={(e) => this.editUserValue({ property: 'email', value: e.target.value })} />
        </FormGroup>
        <FormGroup>
          <Label>Password</Label>
          <Input value={this.state.user.password} type="password" placeholder="Password" onChange={(e) => this.editUserValue({ property: 'password', value: e.target.value })} />
        </FormGroup>
        <FormGroup>
          <Label />
          <Button block color="primary" onClick={() => this.login()}>Login</Button>
        </FormGroup>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/Login/index.js